import { Component, OnInit } from '@angular/core';
declare var $: any;

@Component({
  selector: 'app-promotion',
  templateUrl: './promotion.component.html',
  styleUrls: ['./promotion.component.css']
})
export class PromotionComponent implements OnInit {
  public loader: boolean = false;
  constructor() { }

  ngOnInit(): void {
    $('.preloader').fadeOut(1000);
  }

}
